// ABOUTME: Universal close button component for modals, dialogs, and panels
// ABOUTME: Provides consistent styling with size variants for different contexts

import { cn } from "@shared/lib/utils"
import { CloseIcon } from "@shared/icons/CloseIcon"

interface CCloseButtonProps {
  onClick: () => void
  className?: string
  size?: "sm" | "md" | "lg"
  "aria-label"?: string
}

export const CCloseButton = ({
  onClick,
  className,
  size = "md",
  "aria-label": ariaLabel = "Close",
}: CCloseButtonProps) => {
  const sizeConfig = {
    sm: { button: "p-1", icon: 16 },
    md: { button: "p-1.5", icon: 20 },
    lg: { button: "p-2", icon: 24 },
  }

  const { button: buttonSize, icon: iconSize } = sizeConfig[size]

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer",
        buttonSize,
        className,
      )}
      aria-label={ariaLabel}
    >
      <CloseIcon size={iconSize} />
    </button>
  )
}
